import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[appColorClick]',
  standalone: true
})
export class ColorClickDirective {
  @Output() colorPicked: EventEmitter<any> = new EventEmitter();

  constructor(private el: ElementRef) {}

  @HostListener('click') onClick() {
    const pickedColor = this.rgbToHex(this.el.nativeElement.style.background);

    this.colorPicked.emit(pickedColor);
  }

  rgbToHex(color) {
    if (color.substr(0, 1) === '#') {
      return color;
    }

    const digits = /(.*?)rgb\((\d+), (\d+), (\d+)\)/.exec(color);

    const red = this.addZeroIfNeeded(parseInt(digits[2], 10).toString(16));
    const green = this.addZeroIfNeeded(parseInt(digits[3], 10).toString(16));
    const blue = this.addZeroIfNeeded(parseInt(digits[4], 10).toString(16));

    return ('#' + red + green + blue).toUpperCase();
  }

  addZeroIfNeeded(color) {
    if (color.length === 1) {
      return '0' + color;
    }

    return color;
  }
}
